///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { confidenceTypeColorCodes, userRole } from "./types";

export const getTTTCostStyle = (confidence, role) => {
  let color = confidenceTypeColorCodes.find(
    ({ value }) => value === confidence
  )?.color;
  if (color && role !== userRole.salesRep) {
    return { backgroundColor: color };
  }
};

export default getTTTCostStyle;
